<template>
  <div class="image-card" :style="{'width': width, 'height': height}" :class="classes">
    <img :src="image" class="image-card__mask" alt="">
    <div class="image-card__content" :class="{'pl-5': bordered }">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ImageCard',
    props: {
      image: {
        type: String,
        required: true
      },
      bordered: {
        type: Boolean,
        default: false
      },
      borderColor: {
        type: String,
        default: 'primary'
      },
      height: {
        type: String,
        default: '100%'
      },
      width: {
        type: String,
        default: '100%'
      }
    },
    computed: {
      classes () {
        return {
          bordered: this.bordered,
          [`bordered--${this.borderColor}`]: this.borderColor
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.image-card {
  height: 276px;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  max-width: 100vw;

  &__content {
    padding: 17px 12px;
    position: relative;
  }

  &.bordered {
    border: 12px solid;

    &--primary {
      border-color: var(--color-primary);
    }

    &--secondary {
      border-color: var(--color-secondary);
    }
  }

  &__mask {
    z-index: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
